import React, { useState, useRef, useEffect } from 'react';
import Currency from '../Currency';
import { Link, useHistory } from 'react-router-dom';
import Icon from '../Icon';
import Radium, { StyleRoot } from 'radium';
import { fadeIn } from 'react-animations';

import './Versions.scss';
import { useScroll } from '../../utils/hooks';
import { Loading } from './Loading';
import bem from '../../utils/bem';
import VersionDetails from './VersionDetails';
import MinicuotasBadge from '../MinicuotasCapital/MinicuotasBadge';
import Badge from '../Badge';

const styles = {
  fadeIn: {
    animation: 'x 1s',
    animationName: Radium.keyframes(fadeIn, 'fadeIn'),
  },
};

const Versions = ({
  isLoading,
  versiones,
  setSelectedVersion,
  selectedVersion,
}) => {
  const [height, setHeight] = useState(0);
  const scroll = useScroll();
  const ref = useRef(null);
  const history = useHistory();

  useEffect(() => {
    if (!selectedVersion) return;

    scroll('.version-options--items-item__info-arrow');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedVersion]);

  return isLoading ? (
    <StyleRoot key={'loading-frame'}>
      <div className="version-options--items" style={styles.fadeIn}>
        <Loading />
        <Loading />
        <Loading />
      </div>
    </StyleRoot>
  ) : (
    <StyleRoot key={'data-frame'}>
      <div className="version-options--items" style={styles.fadeIn}>
        {versiones.map(version => {
          return (
            <div key={version.codigo}>
              <div
                className={bem('version-options--items-item', {
                  active: selectedVersion === version.codigo,
                })}
              >
                <div className="version-options--items-badges">
                  {version?.tienePromoCapital === '1' && <MinicuotasBadge />}
                  {version?.nuevo === '1' && <Badge message="Nuevo" noParentAbsolute />}
                </div>
                <button to={`${version.codigo}/${version.anio}/`} onClick={() => {
                  history.push(`${version.codigo}/${version.anio}/`)
                }}>
                  <h6>{version.nombreAmigable}</h6>
                  {/* <h6>{version.marca}</h6>
                                            <span className="nombre-amigable">{version.nombreAmigable}</span> */}
                  <span
                    className="slogan"
                    dangerouslySetInnerHTML={{
                      __html: version.slogan,
                    }}
                  />
                  <ul className="descripcion">
                    {(version.descCorta || '').split('|').map(desc => {
                     return <li key={desc}>{desc.trim()}</li>;
                    })}
                  </ul>
                  <span className="precio">
                    Precio Regular:{' '}
                    <Currency value={version.precioPublico} decimals={0} />
                  </span>
                  <span className="precio">
                    Descuento:{' '}
                    <Currency value={version.descuentoPromocion} decimals={0} />
                  </span>
                  <div className="precio-final">
                    <span className="title">Precio Promocional</span>
                    <span className="valor">
                      <Currency value={version.precioOferta} decimals={0} />
                    </span>
                  </div>
                  {/* <span className="precio">
                    *Cuota aproximada:{' '}
                    <Currency value={version.cuota} decimals={0} />
                  </span>
                  <p className="disclaimer">
                    * Cuota corresponde a cálculo realizado con tasa fija
                    aplicable para los primeros 24 meses.
                  </p> */}
                </button>
                <button to={`${version.codigo}/${version.anio}/`} 
                  onClick={() => {
                    history.push(`${version.codigo}/${version.anio}/`)
                  }}
                  className="version-options--items-item__ver-mas version-options--items-item__ver-mas--color mg-button">
                  Cotizar
                </button>
                <button
                  className="version-options--items-item__ver-mas"
                  onClick={() => {
                    const closing = selectedVersion === version.codigo;
                    if (closing) {
                      scroll('.version-options--items', 90, 'smooth');
                    }

                    setSelectedVersion(closing ? null : version.codigo);
                  }}
                >
                  Ver más <Icon type="down-arrow" />
                </button>
              </div>
              {selectedVersion === version.codigo && (
                <div style={{ ...styles.fadeIn, paddingBottom: height }}>
                  <div className="version-options--items-item__info-arrow special-arrow">
                    <span />
                  </div>
                  <div
                    className="version-options--items-item__info-wrapper"
                    ref={r => {
                      ref.current = r;
                      setHeight(r?.clientHeight || 0);
                    }}
                  >
                    <VersionDetails
                      version={version}
                      scroll={scroll}
                      setSelectedVersion={setSelectedVersion}
                      ref={ref.current}
                      onClickDetail={() => {
                        setTimeout(() => {
                          setHeight(ref.current?.clientHeight || 0);
                        }, 1);
                      }}
                    />
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </StyleRoot>
  );
};

export default Versions;
